import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import MasterHome from "../MasterHome/MasterHome";
import VendorRegistration from "../Vendor/VendorRegistration";
import OnboardingBuilder from "../ClientOnboarding/OnboardingBuilder";
import OnboardingList from "../ClientOnboarding/OnboardingList";
import IndustryMaster from "../IndustryMaster/IndustryMaster";
import AddIndustry from "../IndustryMaster/AddIndustry";
import ChangePassword from "../ChangeAdminPassword/ChangePassword";
import BasicSetup from "../BasicSetup/BasicSetup";
import RulesAndFeatures from "../BasicSetup/RulesAndFeatures";
import MatchRulesConfiguration from "../BasicSetup/MatchRulesConfiguration";
import VendorUpdate from "../Vendor/VendorUpdate";
import UpdateIndustry from "../IndustryMaster/UpdateIndustry";
import FormTemplate from "../FormTemplate/FormTemplate";
import AddForm from "../FormTemplate/AddForm";
import MessageTemplate from "../MessageTemplate/MessageTemplate";
import AddMessageTemplate from "../MessageTemplate/AddMessageTemplate";
import EmailTemplate from "../EmailMaster/EmailCredentials";
import AddEmailTemplate from "../EmailMaster/AddEmailTemplate";
import ProgramSetup from "../ProgramSetup/ProgramSetup";
import AddNewProgramOption from "../ProgramSetup/AddNewProgramOption";
import EditProgramOption from "../ProgramSetup/EditProgramOption";
import Dwan from "../../Dwan";
import "../../../assests/style.css";
import FormSetup from "../FormSetup/FromSetup";
import FormSetupByClient from "../FormSetup/FormSetupByClient";
import VendorTheme from "../VendorTheme/VendorTheme";
import AddVendorTheme from "../VendorTheme/AddVendorTheme";
import AllWorkflow from "../WorkflowSetup/AllWorkflow";
import AddWorkflow from "../WorkflowSetup/AddWorkflow";
import Navbar from "../../../components/Admin/Navbar";
import Sidebar from "../../../components/Admin/Sidebar";
import AppUserType from "../AppUserType/AppUserType";
import AddAppUserType from "../AppUserType/AddAppUserType";
import SmsCredential from "../SmsCredential/SmsCredential";
import SmsCredentialSetup from "../SmsCredential/SmsCredentialSetup";
import AddSMSCredential from "../SmsCredential/AddSMSCredential";
import UpdateSMSCredential from "../SmsCredential/UpdateSMSCredential";
import AppMenu from "../AppSetup/AppMenu";
import ManageAppMenu from "../AppSetup/ManageAppMenu";
import AppDashboard from "../AppSetup/AppDashboard";
import ManageAppDashboard from "../AppSetup/ManageAppDashboard";
import ClientAppSetup from "../AppSetup/ClientAppSetup";
import NotFound from "../../../components/NotFound";
import UomKeys from "../UomMaster/UomKeys";
import UomValues from "../UomMaster/UomValues";
import AddTenantWebDashboard from "../TenantWebDashboardSetup/AddTenantWebDashboard";
import AllTenantWebDashboards from "../TenantWebDashboardSetup/AllTenantWebDashboards";
import AddEmailCredentials from "../EmailMaster/AddEmailCredentials";
import ViewEmailTemplates from "../EmailMaster/ViewEmailTemplates";
import AddTenantSidebar from "../TenantSidebar/AddTenantSidebar";
import ErrorBoundry from "../../../components/ErrorBoundry/ErrorBoundry";
import AllTenantSidebar from "../TenantSidebar/AllTenantSidebar";
import AllFirebaseSetup from "../FirebaseSetup/AllFirebaseSetup";
import AddTenantFirebaseSetup from "../FirebaseSetup/AddFirebaseSetup";
import PincodeMaster from "../PincodeMaster/PincodeMaster";
import EmployeeSetup from "../BasicSetup/EmployeeSetup";
import AdminNotificationTemplate from "../NotificationTemplate/AdminNotificationTemplate";
import AddAdminNotificationTemplate from "../NotificationTemplate/AddAdminNotificationTemplate";
import TenantWallet from "../TenantWallet/TenantWallet";
import AppDowntime from "../AppDowntime/AppDowntime";
import AdminUsers from "../AdminUsers/AdminUsers";
import AdminRoles from "../AdminRoles/AdminRoles";
import EditAdminRolePermission from "../AdminRoles/EditAdminRolePermission";
import ProtectedAdminRoute from "../../../components/Admin/ProtectedAdminRoute";
import LoyaltyCache from "../LoyaltyCache/LoyaltyCache";
import BillingCycle from "../BillingCycle/BillingCycle";
import TenantLoginActivity from "../TenantLoginActivity/TenantLoginActivity";

const Home = () => {
  const isFinanceOnly = sessionStorage.getItem("finance_only") === "true";

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <Navbar />
          {/* <Sidebar /> */}
          <ErrorBoundry>

            <Routes>
              {isFinanceOnly ? (
                <>
                  <Route path="" element={<Navigate to="tenantWallet" replace />} />
                  <Route path="tenantWallet" element={<TenantWallet />} />
                  <Route path="/*" element={<Navigate to="tenantWallet" replace />} />
                </>
              ) : (
                <>
                  <Route path="" element={<ProtectedAdminRoute path=""><MasterHome /></ProtectedAdminRoute>} />
                  <Route path="addVendor" element={<ProtectedAdminRoute path="clients"><VendorRegistration /></ProtectedAdminRoute>} />
                  <Route path="onboardClient" element={<ProtectedAdminRoute path="clients"><OnboardingBuilder /></ProtectedAdminRoute>} />
                  <Route path="onboardings" element={<ProtectedAdminRoute path="clients"><OnboardingList /></ProtectedAdminRoute>} />
                  <Route path="editVendor" element={<ProtectedAdminRoute path="clients"><VendorUpdate /></ProtectedAdminRoute>} />
                  <Route path="vendorTheme" element={<ProtectedAdminRoute path="vendorTheme"><VendorTheme /></ProtectedAdminRoute>} />
                  <Route path="addVendorTheme" element={<ProtectedAdminRoute path="vendorTheme"><AddVendorTheme /></ProtectedAdminRoute>} />
                  <Route path="editVendorTheme" element={<ProtectedAdminRoute path="vendorTheme"><AddVendorTheme /></ProtectedAdminRoute>} />

                  <Route path="industryMaster" element={<ProtectedAdminRoute path="industryMaster"><IndustryMaster /></ProtectedAdminRoute>} />
                  <Route path="addIndustry" element={<ProtectedAdminRoute path="industryMaster"><AddIndustry /></ProtectedAdminRoute>} />
                  <Route path="updateIndustry" element={<ProtectedAdminRoute path="industryMaster"><UpdateIndustry /></ProtectedAdminRoute>} />

                  <Route path="changeAdminPassword" element={<ProtectedAdminRoute path="changeAdminPassword"><ChangePassword /></ProtectedAdminRoute>} />

                  <Route path="basicSetup" element={<ProtectedAdminRoute path="basicSetup"><BasicSetup /></ProtectedAdminRoute>} />
                  <Route path="matchRulesConfiguration" element={<ProtectedAdminRoute path="matchRulesConfiguration"><MatchRulesConfiguration /></ProtectedAdminRoute>} />
                  <Route path="rulesAndFeatures" element={<ProtectedAdminRoute path="rulesAndFeatures"><RulesAndFeatures /></ProtectedAdminRoute>} />
                  <Route path="workflowSetup" element={<ProtectedAdminRoute path="workflowSetup"><AllWorkflow /></ProtectedAdminRoute>} />
                  <Route path="addWorkflow" element={<ProtectedAdminRoute path="workflowSetup"><AddWorkflow /></ProtectedAdminRoute>} />

                  <Route path="formsetup" element={<ProtectedAdminRoute path="formsetup"><FormSetup /></ProtectedAdminRoute>} />
                  <Route path="formSetupByClient" element={<ProtectedAdminRoute path="formsetup"><FormSetupByClient /></ProtectedAdminRoute>} />

                  <Route path="formTemplate" element={<ProtectedAdminRoute path="formTemplate"><FormTemplate /></ProtectedAdminRoute>} />
                  <Route path="addForm" element={<ProtectedAdminRoute path="formTemplate"><AddForm /></ProtectedAdminRoute>} />
                  <Route path="messageTemplate" element={<ProtectedAdminRoute path="messageTemplate"><MessageTemplate /></ProtectedAdminRoute>} />
                  <Route path="addMessageTemplate" element={<ProtectedAdminRoute path="messageTemplate"><AddMessageTemplate /></ProtectedAdminRoute>} />

                  <Route path="emailCredential" element={<ProtectedAdminRoute path="emailCredential"><EmailTemplate /></ProtectedAdminRoute>} />
                  <Route path="addEmailCredential" element={<ProtectedAdminRoute path="emailCredential"><AddEmailCredentials /></ProtectedAdminRoute>} />
                  <Route path="addEmailTemplate" element={<ProtectedAdminRoute path="emailCredential"><AddEmailTemplate /></ProtectedAdminRoute>} />
                  <Route path="viewEmailTemplate" element={<ProtectedAdminRoute path="emailCredential"><ViewEmailTemplates /></ProtectedAdminRoute>} />

                  <Route path="dwan" element={<ProtectedAdminRoute path="dwan"><Dwan /></ProtectedAdminRoute>} />

                  <Route path="program" element={<ProtectedAdminRoute path="program"><ProgramSetup /></ProtectedAdminRoute>} />
                  <Route path="addNewOption" element={<ProtectedAdminRoute path="program"><AddNewProgramOption /></ProtectedAdminRoute>} />
                  <Route path="editOption" element={<ProtectedAdminRoute path="program"><EditProgramOption /></ProtectedAdminRoute>} />

                  <Route path="appUsers" element={<ProtectedAdminRoute path="appUsers"><AppUserType /></ProtectedAdminRoute>} />
                  <Route path="addAppUserType" element={<ProtectedAdminRoute path="appUsers"><AddAppUserType /></ProtectedAdminRoute>} />

                  <Route path="appMenu" element={<ProtectedAdminRoute path="appMenu"><AppMenu /></ProtectedAdminRoute>} />
                  <Route path="appMenu/add" element={<ProtectedAdminRoute path="appMenu"><ManageAppMenu /></ProtectedAdminRoute>} />

                  <Route path="appDashboard" element={<ProtectedAdminRoute path="appDashboard"><AppDashboard /></ProtectedAdminRoute>} />
                  <Route path="appDashboard/add" element={<ProtectedAdminRoute path="appDashboard"><ManageAppDashboard /></ProtectedAdminRoute>} />

                  <Route path="clientAppSetup" element={<ProtectedAdminRoute path="appMenu"><ClientAppSetup /></ProtectedAdminRoute>} />

                  <Route path="smsCredential" element={<ProtectedAdminRoute path="smsCredential"><SmsCredentialSetup /></ProtectedAdminRoute>} />
                  <Route path="smsCredentialLegacy" element={<ProtectedAdminRoute path="smsCredential"><SmsCredential /></ProtectedAdminRoute>} />
                  <Route path="addSMSCredential" element={<ProtectedAdminRoute path="smsCredential"><AddSMSCredential /></ProtectedAdminRoute>} />
                  <Route path="updateSMSCredential" element={<ProtectedAdminRoute path="smsCredential"><UpdateSMSCredential /></ProtectedAdminRoute>} />

                  <Route path="uomKeys" element={<ProtectedAdminRoute path="uomKeys"><UomKeys /></ProtectedAdminRoute>} />
                  <Route path="uomValues" element={<ProtectedAdminRoute path="uomKeys"><UomValues /></ProtectedAdminRoute>} />
                  <Route path="tenantWebDashboard" element={<ProtectedAdminRoute path="tenantWebDashboard"><AllTenantWebDashboards /></ProtectedAdminRoute>} />
                  <Route path="tenantWebDashboard/add" element={<ProtectedAdminRoute path="tenantWebDashboard"><AddTenantWebDashboard /></ProtectedAdminRoute>} />
                  <Route path="tenantSidebar" element={<ProtectedAdminRoute path="tenantSidebar"><AllTenantSidebar /></ProtectedAdminRoute>} />
                  <Route path="tenantSidebar/manage" element={<ProtectedAdminRoute path="tenantSidebar"><AddTenantSidebar /></ProtectedAdminRoute>} />

                  <Route path="pincode-master" element={<ProtectedAdminRoute path="pincodeMaster"><PincodeMaster /></ProtectedAdminRoute>} />
                  <Route path="employee-setup" element={<ProtectedAdminRoute path="employeeSetup"><EmployeeSetup /></ProtectedAdminRoute>} />

                  <Route path="firebaseSetup" element={<ProtectedAdminRoute path="firebaseSetup"><AllFirebaseSetup /></ProtectedAdminRoute>} />
                  <Route path="firebaseSetup/add" element={<ProtectedAdminRoute path="firebaseSetup"><AddTenantFirebaseSetup /></ProtectedAdminRoute>} />

                  <Route path="notificationTemplate" element={<ProtectedAdminRoute path="notificationTemplate"><AdminNotificationTemplate /></ProtectedAdminRoute>} />
                  <Route path="notificationTemplate/add" element={<ProtectedAdminRoute path="notificationTemplate"><AddAdminNotificationTemplate /></ProtectedAdminRoute>} />
                  <Route path="notificationTemplate/edit" element={<ProtectedAdminRoute path="notificationTemplate"><AddAdminNotificationTemplate /></ProtectedAdminRoute>} />

                  <Route path="tenantWallet" element={<ProtectedAdminRoute path="tenantWallet"><TenantWallet /></ProtectedAdminRoute>} />
                  <Route path="appDowntime" element={<ProtectedAdminRoute path="appDowntime"><AppDowntime /></ProtectedAdminRoute>} />

                  <Route path="adminUsers" element={<ProtectedAdminRoute path="adminUsers"><AdminUsers /></ProtectedAdminRoute>} />
                  <Route path="adminRoles" element={<ProtectedAdminRoute path="adminRoles"><AdminRoles /></ProtectedAdminRoute>} />
                  <Route path="adminRoles/editPermission" element={<ProtectedAdminRoute path="adminRoles"><EditAdminRolePermission /></ProtectedAdminRoute>} />
                  <Route path="loyaltyCache" element={<ProtectedAdminRoute path="loyaltyCache"><LoyaltyCache /></ProtectedAdminRoute>} />
                  <Route path="billing-cycle" element={<ProtectedAdminRoute path="billingCycle"><BillingCycle /></ProtectedAdminRoute>} />
                  <Route path="tenantLoginActivity" element={<ProtectedAdminRoute path="tenant Login Activity"><TenantLoginActivity /></ProtectedAdminRoute>} />

                  <Route path="/*" element={<NotFound />} />
                </>
              )}
            </Routes>
          </ErrorBoundry>

        </div>
      </div>
    </>
  );
};

export default Home;
